import WebsiteModal from "modals/WebsiteModal";
import YTPlayer from "util/YTPlayer";

export default class VideoModal extends WebsiteModal {
    constructor(videoSrc, $pageVideoElement) {
        super();
        this.videoSrc = videoSrc;
        this.$pageVideoElement = $pageVideoElement;
        this.localVideo = false;

        if (this.videoSrc.includes('.mp4')) {
            this.localVideo = true;
        } else {
            this.videoID = this.videoSrc;
        }

    }

    buildElement() {
        let videoStructure

        if (this.localVideo === true) {
            videoStructure = eotwJSXFactory('video', {autoPlay: true, loop: true, controls: true, muted: true}, [
                eotwJSXFactory('source', {src: this.videoSrc, type: "video/mp4"})
            ])
        } else {
            videoStructure = eotwJSXFactory('div', {className: "js-video-container"})
        }

        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--loading"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container"}),
                eotwJSXFactory('button', {className: "modal__close js-close-modal", title: "Close", 'aria-label': "Close Modal"})
            ])
        );
        this.$modal.addClass('modal--video modal--no-border-top').removeClass('modal--loading').find(".modal__container").append(
            eotwJSXFactory('div', {className: 'modal__video js-video'}, [
                videoStructure
            ])
        );
    }

    bindEvents() {
        if (this.localVideo === false) {
            this.player = new YTPlayer(this.$modal.find('.js-video'), this.videoID);
        }
    }

    destroy() {
        super.destroy();
        if (this.player !== null) {
            this.player.destroy();
            this.player = null;
        }
    }

    close() {
        super.close();
        this.$pageVideoElement[0].play();
    }
}
